import {
  CustomButton,
  SearchBar,
  SwitchButton,
  searchDateFormat,
} from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import { dateFormat, } from "utils/dateFormat";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import useButtonLoader from "common/UseButtonLoader";
import { FaRegEdit, FaRegTrashAlt, FaRegEye } from "react-icons/fa";
import useDebounce from "common/UseDebounce";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import { SlRefresh } from "react-icons/sl";
import { DatePicker, Input, Select, timeFormat } from "common/InputForm";
import { toast } from "sonner";

import { updatePostStatus } from "services/post";
import { userPlaceholder } from "assets/icons";
import "./postManagement.scss";
import { charLimit } from "utils/formValidator";
import { removeReportApi, reportListApi } from "services/report";
import Report from "./Report";
import { capitalFirstLetter } from "utils/text";

const ReportManagement = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [reportList, setReportList] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [fieldName, setFieldName] = useState("");
  const [direaction, setDirection] = useState("");
  const [buttonLoaderFile, setButtonLoaderFile] = useButtonLoader("Export");
  const [searchParams, setSearchParams] = useSearchParams();
  const [selected, setSelected] = useState({});
  const [statusModal, setStatusModal] = useState(false);
  const [total, setTotal] = useState(null);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Yes");
  const activePage = +searchParams.get("page") || 1;

  const limits = +searchParams.get("limit") || 10;
  const statusValue = searchParams.get("status") || "";
  const [descriptionModal, setDescriptionModal] = useState(false);
  const [description, setDescription] = useState("");

  const [imagePreview, setImagePreview] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [loader, onShow, onHide] = useFullPageLoader();
  const [reportDetails, setReportDetails] = useState({ modal: false, id: '' })
  // sort
  const toggleSortOrder = () => {
    setDirection(direaction === "ASC" ? "DESC" : "ASC");
  };
  const handleSort = (field) => {
    if (field === fieldName) {
      toggleSortOrder();
    } else {
      setFieldName(field);
      setDirection("ASC");
    }
  };
  // delete handler
  const deleteHandler = (id) => {
    setSelected({ reportId: id, action: "delete" });
    setDeleteModal(true);
  };
  // change delete handler
  const changeDeleteHandler = async () => {
    try {
      setButtonLoaders(true);
      const res = await removeReportApi(selected.reportId);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "delete");
        searchParams.delete("page");
        reportListHandler();
        setDeleteModal(false);
      } else {
        toastMessage(res.data.message, "error", "delete");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoaders(false);
    }
  };


  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("status");
    searchParams.delete("page");

    setSearch("");
    setSearchParams(searchParams);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  /**************Modal CLose*********************/
  const closeModal = () => {
    setStatusModal(false);
    setSelected({});
  };
  //-----------status-------------
  const handleStatus = (event) => {
    const value = event.target.value;
    searchParams.set("status", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };

  //--------------handle-Report--------------------
  const handleReport = (data) => {
    setReportDetails({ modal: true, id: data?.reportId })
  }
  //------------close-Report-Modal-----------------
  const closeReportModal = () => {
    setReportDetails({ modal: false, id: "" });
  };

  // report list handler
  const reportListHandler = async (
    page = activePage,
    limit = limits,
    search = debouncedValue,
    sortField = fieldName || "",
    sortDirection = direaction,
    reportType = statusValue || "post",
  ) => {
    try {
      onShow();
      const res = await reportListApi({
        page,
        limit,
        search,
        sortField,
        sortDirection,
        reportType,
      });
      // console.log(res, "yfdtr")
      if (res?.data?.status === 200) {
        // toastMessage(res?.data?.message,"success" ,"reportList");
        setTotal(res.data.total);
        setReportList(res.data?.data?.reports);
        onHide();
      } else {
        toastMessage(res?.data?.message, "error", "reportList");
        onHide();

      }
    } catch (e) {
      onHide();
      toast.error(e.message);
    }
  };

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    reportListHandler();
  }, [
    // searchParams,
    debouncedValue,
    fieldName,
    direaction,
    activePage,
    statusValue,

  ]);
  useEffect(() => {
    if (search) {
      searchParams.delete("page");
    }
  }, []);

  return (
    <>
      <div className="student_management">
        <div className="card top_card">
          <div className="dashboard_title has_child">
            <h3>Report Management</h3>


          </div>
          <div className="button_section_wrap">
            <div className="search_wrapper">
              <SearchBar
                placeholder={"Search..."}
                onChange={(e) => {
                  setSearch(e.target.value);
                  searchParams.delete("page");
                  setSearchParams(searchParams);
                }}
                value={search}
              />

              <div className="d-flex align-items-center">
                <select
                  className="input form-control"
                  value={statusValue}
                  onChange={handleStatus}
                >

                  <option value="post">Post</option>
                  <option value="comment">Comment</option>
                  <option value="reply">Reply</option>

                </select>


                <CustomButton onClick={resetFilterHandler}>Reset</CustomButton>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>

                  <tr>
                    <th>S.No.</th>

                    <th>Content Preview </th>
                    <th
                      className="nowrap cursor-pointer text-center"
                      onClick={() => handleSort("totalReports")}
                    >
                      Total Reports
                      <span className="shorting">
                        {fieldName === "totalReports"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th>Reported By  </th>
                    <th className="nowrap">Reason</th>
                    <th className="nowrap">Status</th>
                    <th className="text-center">Remove</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {reportList && reportList.length > 0 ? (
                    reportList?.map((data, index) => {
                      return (
                        <tr key={++index}>
                          {/* <td>{index + 1}</td> */}
                          <td>{++index + (activePage - 1) * 10}</td>

                          <td>{data?.contentPreview}</td>

                          <td className="text-center">{data?.totalReports}</td>


                          <td>{data?.reportedBy}</td>
                          <td className="nowrap">
                            {data?.reason.length > 50 ? (
                              <div className="d-flex wrap_td_span">
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: charLimit(data?.reason, 30),
                                  }}
                                ></p>
                                &nbsp;
                                <button
                                  className="readMore"
                                  onClick={() => {
                                    setDescriptionModal(true);
                                    setDescription(
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html: data?.reason,
                                        }}
                                      ></p>
                                    );
                                  }}
                                >
                                  <b>Read More</b>
                                </button>
                              </div>
                            ) : (
                              <div className="d-flex wrap_td_span">
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: data?.reason,
                                  }}
                                ></p>
                              </div>
                            )}
                          </td>
                          <td className="nowrap">
                            {data?.status === 'pending' ?
                              <button className="button" onClick={() => handleReport(data)}> {capitalFirstLetter(data?.status)}</button>
                              :
                              <button disabled className="button"> {capitalFirstLetter(data?.status)}</button>
                            }
                          </td>
                          <td>
                            <div className="icon_wrap">

                              <Link
                                to=""
                                className="icon_button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  deleteHandler(data?.reportId);
                                }}
                              >
                                <FaRegTrashAlt />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={7}
                      msg={"Report data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>
            {total > limits && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limits}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Delete Report Modal */}
      <PopupModal
        show={deleteModal}
        handleClose={() => {
          setSelected({});
          setDeleteModal(false);
        }}
        content="Are you sure you want to delete this Report?"
        title="Delete Report"
        onShow={changeDeleteHandler}
        buttonLoader={buttonLoaders}
      />

      <CustomModal
        className={"image_preview_modal"}
        show={imagePreview}
        handleClose={() => setImagePreview(false)}
      >
        <div className="image_preview">
          <img src={imageUrl ? imageUrl : userPlaceholder} alt="" />
        </div>
      </CustomModal>

      {descriptionModal && (
        <CustomModal
          className={"add_model"}
          show={descriptionModal}
          handleClose={() => {
            setDescriptionModal(false);
          }}
        >
          <h3>Description</h3>
          <h7>{description}</h7>
        </CustomModal>
      )}

      {reportDetails?.modal &&
        <Report
          reportDetails={reportDetails}
          close={closeReportModal}
          listing={reportListHandler}
        />
      }
    </>
  );
};

export default ReportManagement;
